import React from "react"
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { IconSeeker } from "@ui-seeker/core"

import { AppBulkEditAction, AppNote } from "@components"
import { dsColorNew } from "@palette"


// A white card on the content grey, as the login: the code, what happened, the way back and the migration note
export default function NotFoundPage() {
	const navigate = useNavigate()

	return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 2, backgroundColor: dsColorNew.contentBg }}>
		<Box sx={{
			width: 1, maxWidth: 480, textAlign: 'center', p: 5,
			backgroundColor: dsColorNew.white, border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '16px',
		}}>
			<Box sx={{ width: 56, height: 56, mx: 'auto', mb: 2.5, borderRadius: '14px', backgroundColor: dsColorNew.pillActiveBg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<IconSeeker icon="compass" sx={{ fontSize: 26, color: dsColorNew.appBlue }}/>
			</Box>
			<Typography sx={{ fontSize: 64, fontWeight: 700, lineHeight: 1, color: dsColorNew.textTitle, mb: 1.5 }}>
				404
			</Typography>
			<Typography sx={{ fontSize: 16, color: dsColorNew.textMuted, mb: 3 }}>
				The page you’re looking for doesn’t exist.
			</Typography>
			<AppBulkEditAction onClick={() => navigate('/login')} sx={{ px: 3, height: 40 }}>
				Go to Login
			</AppBulkEditAction>
			<AppNote sx={{ mt: 4, textAlign: 'left' }}>
				<Box sx={{ fontWeight: 600, mb: 0.5 }}>Why im I seeing this?</Box>
				We’re currently migrating to a new version of Price Seeker Rentacar.
				Please note that there may be inconsistencies when using links from the previous version in the new system. If you need any
				assistance, don't hesitate to contact us.
			</AppNote>
		</Box>
	</Box>
}
